<div class="preview-banner">
  <span class="banner-label">
    <mat-icon class="material-symbols-outlined">visibility</mat-icon>
    Pré-visualização — é assim que o fornecedor verá o pedido. Valores de exemplo.
  </span>
  <button mat-icon-button type="button" class="preview-close" (click)="fechar()" matTooltip="Fechar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="portal-page">
  <div class="portal-doc">

    <header class="portal-hero" [style.background]="heroGradient">
      <div class="hero-brand">
        @if (data.urlLogo) {
          <span class="hero-logo"><img [src]="data.urlLogo" alt="Logo"></span>
        } @else {
          <span class="hero-logo-fallback" [style.background]="data.corMarca">{{ data.marcaSigla }}</span>
        }
        <div class="hero-brand-text">
          <strong>{{ data.razaoSocial || 'Sua empresa' }}</strong>
          <span>{{ data.marcaRodape }}</span>
        </div>
      </div>
      <div class="hero-meta">
        <div class="hero-doc-type">Pedido de compra</div>
        <div class="hero-doc-number">PED-2026-0108</div>
        <div class="hero-chips">
          <span class="hero-chip">
            <mat-icon class="material-symbols-outlined">event</mat-icon>
            Emitido em 02/07/2026
          </span>
          <span class="hero-chip">
            <mat-icon class="material-symbols-outlined">verified</mat-icon>
            Aprovado
          </span>
        </div>
      </div>
    </header>

    <div class="portal-body">

      @if (data.mensagem) {
        <section class="portal-section">
          <p class="portal-mensagem">{{ data.mensagem }}</p>
        </section>
      }

      <section class="portal-section">
        <div class="partes-grid">
          <div class="parte-card">
            <h3 class="portal-section-title"><i [style.background]="data.corMarca"></i>Comprador</h3>
            <div class="parte-body">
              <strong>{{ data.razaoSocial || 'Sua empresa' }}</strong>
              <span>CNPJ {{ data.cnpj || '—' }}</span>
              <span>{{ data.endereco || '—' }}</span>
              <span>{{ data.emailContato }} · {{ data.telefoneContato }}</span>
            </div>
          </div>
          <div class="parte-card">
            <h3 class="portal-section-title"><i [style.background]="data.corMarca"></i>Fornecedor</h3>
            <div class="parte-body">
              <strong>Distribuidora Alfa Suprimentos Ltda</strong>
              <span>CNPJ 12.345.678/0001-90</span>
              <span>Rua das Indústrias, 850 - Galpão 4 - Joinville/SC - CEP 89201-405</span>
              <span>vendas&#64;alfasuprimentos.com.br · (47) 3422-1188</span>
            </div>
          </div>
        </div>
      </section>

      <section class="portal-section">
        <h3 class="portal-section-title"><i [style.background]="data.corMarca"></i>Itens do pedido</h3>
        <div class="items-scroll">
          <table class="items-table">
            <thead>
              <tr>
                <th class="num">Item</th>
                <th>Produto</th>
                <th class="num">Qtd</th>
                <th>Un</th>
                <th class="num">Preço unitário</th>
                <th class="num">Tributos</th>
                <th class="num">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              @for (item of itens; track item.sku; let i = $index) {
                <tr>
                  <td class="num">{{ i + 1 }}</td>
                  <td class="item-nome">
                    <strong>{{ item.nome }}</strong>
                    <small>SKU {{ item.sku }}</small>
                  </td>
                  <td class="num">{{ item.quantidade }}</td>
                  <td>{{ item.unidade }}</td>
                  <td class="num">{{ item.precoUnitario }}</td>
                  <td class="num">{{ item.tributos }}</td>
                  <td class="num">{{ item.subtotal }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div class="totais-box">
          <div class="totais-row"><span>Subtotal dos itens</span><span>R$ 23.258,55</span></div>
          <div class="totais-row"><span>Frete</span><span>R$ 380,00</span></div>
          <div class="totais-row"><span>Outras despesas</span><span>R$ 170,00</span></div>
          <div class="totais-row totais-row--total" [style.color]="data.corMarca">
            <span>Total geral</span><span>R$ 23.808,55</span>
          </div>
        </div>
      </section>

      @if (isAtivo('campoCondicoesPagamento')) {
        <section class="portal-section">
          <h3 class="portal-section-title"><i [style.background]="data.corMarca"></i>Condições de pagamento</h3>
          <p class="condicao-resumo">Boleto bancário · 3 parcelas (28/56/84 dias)</p>
          <table class="parcelas-table">
            <thead>
              <tr><th>Parcela</th><th>Vencimento</th><th class="num">Valor</th></tr>
            </thead>
            <tbody>
              @for (parcela of parcelas; track parcela.sequencia) {
                <tr>
                  <td>{{ parcela.sequencia }}</td>
                  <td>{{ parcela.vencimento }}</td>
                  <td class="num">{{ parcela.valor }}</td>
                </tr>
              }
            </tbody>
          </table>
        </section>
      }

      @if (isAtivo('campoPrazoEntrega')) {
        <section class="portal-section">
          <h3 class="portal-section-title"><i [style.background]="data.corMarca"></i>Entrega</h3>
          <div class="info-grid">
            <div class="info-item">
              <small>Prazo de entrega</small>
              <span>Até 15/07/2026 (10 dias úteis)</span>
            </div>
            <div class="info-item">
              <small>Frete</small>
              <span>CIF — por conta do fornecedor</span>
            </div>
            <div class="info-item info-wide">
              <small>Local de entrega</small>
              <span>{{ data.endereco || 'Endereço da empresa' }}</span>
            </div>
          </div>
        </section>
      }

      @if (isAtivo('campoObservacoes')) {
        <section class="portal-section">
          <h3 class="portal-section-title"><i [style.background]="data.corMarca"></i>Observações do pedido</h3>
          <p class="portal-mensagem">
            Entregar em horário comercial (8h–17h) na portaria 2. Agendar a descarga com 24h de
            antecedência pelo telefone do setor de compras. A nota fiscal deve referenciar o número deste pedido.
          </p>
        </section>
      }
    </div>

    <footer class="portal-footer">
      <strong>{{ data.razaoSocial || 'Sua empresa' }}</strong> · {{ data.emailContato }} · {{ data.telefoneContato }}
      <br>{{ data.urlSite }}
    </footer>
  </div>
</div>
